export const formStyles = {
    warningContainer: {
        marginBottom: '30px',
        backgroundColor: '#ffe0db',
        padding: '15px',
        borderRadius: '8px',
        border: '1px solid #ffcccc'
    },
    warningContent: {
        display: 'flex',
        alignItems: 'flex-start'
    },
    warningIcon: {
        width: '20px',
        height: '20px',
        marginRight: '10px',
        marginTop: '2px',
        flexShrink: 0,
        color: '#c0392b'
    },
    warningTitle: {
        fontWeight: 'bold',
        color: '#c0392b',
        display: 'block',
        marginBottom: '4px'
    },
    warningText: {
        color: '#555'
    },
    stepIndicatorContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '40px',
        padding: '0 20px'
    },
    stepItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative'
    },
    stepCircle: (isActive, isCompleted) => ({
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: (isActive || isCompleted) ? '#2c3e50' : '#ecf0f1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '12px',
        boxShadow: isActive ? '0 4px 12px rgba(44, 62, 80, 0.3)' : 'none',
        transition: 'all 0.3s'
    }),
    stepIcon: (isActive) => ({
        width: '30px',
        height: '30px',
        color: isActive ? 'white' : '#95a5a6'
    }),
    stepLabel: (isActive) => ({
        fontSize: '13px',
        color: isActive ? '#2c3e50' : '#7f8c8d',
        fontWeight: isActive ? 'bold' : 'normal',
        textAlign: 'center',
        maxWidth: '120px'
    }),
    stepConnector: (isCompleted) => ({
        width: '100px',
        height: '3px',
        backgroundColor: isCompleted ? '#2c3e50' : '#ecf0f1',
        margin: '0 15px 40px 15px',
        transition: 'all 0.3s'
    }),
    stepContentContainer: {
        backgroundColor: '#fff',
        padding: '15px',
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        marginBottom: '25px',
        minHeight: '350px'
    },
    stepHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '30px',
        paddingBottom: '15px',
        borderBottom: '2px solid #f8f9fa'
    },
    stepHeaderIcon: {
        width: '32px',
        height: '32px',
        color: '#e74c3c',
        marginRight: '15px'
    },
    stepHeaderTitle: {
        margin: 0,
        color: '#2c3e50',
        fontSize: '22px',
        fontWeight: 'bold'
    },
    formLabel: {
        fontWeight: '600',
        marginBottom: '8px',
        color: '#34495e'
    },
    inputReadOnly: {
        backgroundColor: '#f8f9fa',
        cursor: 'not-allowed'
    },
    deliveryCard: (isSelected) => ({
        flex: 1,
        border: isSelected ? '2px solid #e74c3c' : '2px solid #e0e0e0',
        borderRadius: '12px',
        padding: '24px',
        cursor: 'pointer',
        position: 'relative',
        backgroundColor: isSelected ? '#fff5f5' : '#fff',
        transition: 'all 0.3s',
        boxShadow: isSelected ? '0 4px 12px rgba(231, 76, 60, 0.2)' : '0 2px 4px rgba(0,0,0,0.05)'
    }),
    deliveryCheckmark: {
        position: 'absolute',
        top: '12px',
        right: '12px',
        width: '28px',
        height: '28px',
        backgroundColor: '#e74c3c',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    summaryContainer: {
        backgroundColor: '#f8f9fa',
        padding: '25px',
        borderRadius: '12px',
        border: '1px solid #e9ecef'
    },
    summaryItemTitle: {
        fontSize: '13px',
        color: '#7f8c8d',
        display: 'block',
        marginBottom: '4px'
    },
    summaryItemValue: {
        fontSize: '15px',
        fontWeight: '600',
        color: '#2c3e50'
    },
    navButtonsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '30px',
        width: "100%"
    },
    buttonBase: (bgColor, hoverColor) => ({
        backgroundColor: bgColor,
        color: 'white',
        border: 'none',
        padding: '12px 20px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.3s'
    })
};
